module.exports = __webpack_public_path__ + "static/img/anow.5f56bf3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/lender/anow.png
// module id = 7u1d
// module chunks = 1